<template>
  <div>
    <v-card class="mt-5">
      <v-card-title>Nouvelle date d'hospitalisation de jour</v-card-title>
      <v-card-text>

        <v-dialog v-model="newRDV.ui.dialog"
                  width="80%">
          <template v-slot:activator="scope">
            <div style="display: flex; flex-direction: row">
              <span style="font-size: 18px; margin-right: auto; align-self: center">Créer un nouveau rendez-vous en Hôpital de jour (avec un nouveau parcours PréHop) : </span>
              <v-btn v-on="scope.on" :loading="newRDV.ui.loading" class="primary" style="margin-left: auto">Créer</v-btn>
            </div>
          </template>

          <v-card>
            <v-card-title class="headline primary white--text"
                          primary-title>
              <span>Nouvelle admission en hôpital de jour</span>
            </v-card-title>

            <v-card-text class="pt-5" style="display: flex; flex-direction: column; font-size: 17px">
                    <span style="margin-bottom: 15px">
                      <b>Contexte</b> : Vous souhaitez déclencher un nouveau parcours complet de pré-admission en hôpital de jour.
                    </span>
              <span style="margin-bottom: 15px">
                      <b>Objectif</b> : Attribuer un rendez-vous et une série de questionnaires préalables à ce patient.
                    </span>
              <span><b>Instructions</b> : Pour réaliser cette mission, vous devez :</span>
              <ul style="margin-bottom: 10px">
                <li>Choisir un motif, une date et une heure de rendez-vous</li>
                <li>Valider</li>
              </ul>

              <span class="primary--text" style="font-style: italic"><v-icon class="mr-1">warning</v-icon>Si vous souhaitez attribuer un rendez-vous sans déclencher les questionnaires, vous devez le faire depuis l'onglet « <b class="primary--text">Rendez-vous</b> » du compte du patient.</span>
              <v-divider color="gray" class="mb-3"></v-divider>
              <span>Prénom : {{(patient.data) ? patient.data.first_name : null}}</span>
              <span>Nom : {{(patient.data) ? patient.data.last_name : null}}</span>
              <span>Numéro de téléphone : {{(patient.data) ? patient.data.user.phone_number : null}}</span>
              <span>e-mail : {{(patient.data) ? patient.data.user.email : null}}</span>

              <span style="margin: 30px 0px; font-size: 18px">Modalités du rendez-vous d'hôpital de jour :</span>

              <IriadeSelect label="Motif hôpital de jour"
                            prepend-icon="subject"
                            :items="appointmentTypes.map(t => ({value: t.label, text: t.label}))"
                            v-model="newRDV.rdvData.motif_hdj"
                            @input=""/>

              <IriadeTextInput v-model="newRDV.rdvData.date_hdj"
                               prepend-icon="event"
                               label="Date d'hospitalisation de jour"
                               type="date"/>

              <IriadeTextInput v-model="newRDV.rdvData.time_hdj"
                               prepend-icon="schedule"
                               label="Heure d'hospitalisation de jour"
                               type="time"/>


            </v-card-text>

            <v-divider color="gray" class="mb-n1"/>

            <v-card-actions>
              <div class="flex-grow-1"></div>

              <v-btn text
                     @click="cancelNewRDV">Retour
              </v-btn>
              <v-btn color="primary"
                     text
                     :loading="newRDV.ui.loading"
                     :disabled="newRDV.rdvData.date_hdj === null || newRDV.rdvData.time_hdj === null || newRDV.rdvData.motif_hdj === null"
                     @click="submitNewRDV">
                <b class="primary--text">Valider</b>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <FindPatientModuleCard v-if="doctorMissions.length"
                           title="Actions en attente">
      <component v-for="doctorMission in doctorMissionsComponents"
                 :key="doctorMission.id"
                 :is="doctorMission.component"
                 :mission="doctorMission"
                 @finished="refresh"></component>
    </FindPatientModuleCard>
    <IriadeEmptyCard v-else>Aucune action en attente.</IriadeEmptyCard>

    <FindPatientModuleCard v-for="patientStack in patientStacks"
                           :key="patientStack.id"
                           :title="`Parcours ${patientStack.stack.label} pour un ${patientStack.params.motif_hdj} le ${dateHdj(patientStack)}`">
      <p>Démarrage le {{patientStack.starts_at}}</p>
      <h3>Missions</h3>
      <ul>
        <li v-for="mission in patientStack.missions"
            :key="mission.id">
          {{mission.module.label}}
          <v-icon v-if="mission.done_at"
                  @click="getMissionResults(mission.id)"
                  class="success--text pointer">check_circle_outline
          </v-icon>
        </li>
      </ul>
      <IriadeSettingsDialog :show="missionDialog.mission.id"
                            v-if="missionDialog.mission.id">
        <v-card>
          <v-card-title class="headline primary white--text"
                        style="display: flex; justify-content: space-between">Mission
            <span @click="missionDialog.mission = {}">X</span>
          </v-card-title>
          <v-card-text>
            <div v-for="formBlock in missionDialog.mission.blocks.filter(b => typeof b.config.form === 'object')">
              <div v-for="section in formBlock.config.form.sections">
                <h3>{{section.label}}</h3>
                <div v-for="input in section.inputs">
                  {{input.label}} : {{missionDialog.mission.data.forms[formBlock.config.form.class_name].sections[section.name][input.name]}}
                </div>
              </div>
            </div>
            <hr>
          </v-card-text>
        </v-card>
      </IriadeSettingsDialog>

      <div v-if="patientStack.reports.length">
        <h3 class="mt-5">Rapports</h3>
        <ul>
          <li v-for="report in patientStack.reports">
            <router-link :to="{name: 'doctors@report', params: {report_id: report.id}}">{{report.label}}</router-link>
          </li>
        </ul>
      </div>
    </FindPatientModuleCard>

    <IriadeEmptyCard v-if="!patientStacks.length">Aucun parcours.</IriadeEmptyCard>
  </div>
</template>

<script>
  import IriadePatientTimeline from '../../../Screens/Doctor/FindPatient/IriadePatientTimeline'
  import IriadeDatepicker from 'components/Iriade/IriadeDatepicker'
  import api from 'api'
  import moment from 'moment'
  import FindPatientModuleCard from "../../../Screens/Doctor/FindPatient/FindPatientModuleCard"

  export default {
    components: {IriadePatientTimeline, IriadeDatepicker, FindPatientModuleCard},

    computed: {
      doctorMissionsComponents () {
        if (this.doctorMissions.length) {
          return this.doctorMissions
            .map(doctorMission => {
              return {
                ...doctorMission,
                component: () => import(`components/Applications/${this.$application.name}/DoctorMissionModules/${doctorMission.module.class_name.split('\\').slice(-1)[0]}`),
              };
            });
        }
      },
    },

    props: ['patient'],

    data () {
      return {
        newRDV: {
          ui: {
            loading: false,
            dialog: false,
          },
          rdvData: {
            date_hdj: null,
            time_hdj: null,
            motif_hdj: null,
          }
        },
        missionDialog: {
          mission: {}
        },
        doctorMissions: [],
        // patient: {},
        patientStacks: [],

        appointmentTypes: [],
      };
    },

    methods: {
      cancelNewRDV () {
        this.newRDV.rdvData.motif_hdj = null;
        this.newRDV.rdvData.date_hdj = null;
        this.newRDV.ui.dialog = false;
      },

      dateHdj (patientStack) {
        return `${moment(patientStack.params.date_hdj).format('DD MMMM YYYY')}`;
      },

      submitNewRDV () {
        this.newRDV.ui.loading = true;
        api.post(`prehop/newRDV/${this.$route.params.patient_id}`, this.newRDV.rdvData)
          .then(res => {
            this.newRDV.ui.loading = false;
            this.newRDV.ui.dialog = false;
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            });
            this.refreshPatientStacks();
          })
          .catch(res => {
            console.log(res);
            this.newRDV.ui.loading = false;
            this.$mango.snackbar({
              color: 'error',
              text: "Something went wrong"
            });
          })
      },

      async refresh() {
        this.doctorMissions = (await api.get(`doctors/missions/${this.$route.params.patient_id}`)).data;

        if (this.$iriade.me().teams.length > 0) {
          api.get(`appointments/types/${this.$iriade.me().teams[0].id}`)
            .then(res => {
              this.appointmentTypes = res.data
            })
        } else {
          api.get(`appointments/types`)
            .then(res => {
              this.appointmentTypes = res.data
            })
        }

        this.refreshPatientStacks();
      },

      async refreshPatientStacks() {
        this.patientStacks = (await api.get(`patients/${this.$route.params.patient_id}/timeline`)).data.stacks.reverse();
      },

      async getMissionResults (mission_id) {
        this.missionDialog.mission = (await api.get(`patients/timeline/missions/${mission_id}`)).data;
      },
    },

    mounted() {
      this.refresh();
    },
  }
</script>
